// Stub for iceberg-js - only used by Supabase storage analytics which we don't use in landing app
// This prevents Vite from trying to pre-bundle a package with incorrect package.json entry point

export const IcebergRestCatalog = class {
  constructor() {
    // Empty stub
  }
}

export default {
  IcebergRestCatalog
}

